module.exports = "/images/vendor/flag-icon-css/flags/1x1/dk.svg?d046fb5b6363db6e655b3c1011c6f779";